import styled from 'styled-components';
import '../../index.css';
import ChartsAnimationF from './ChartsAnimationF';
import ChartsAnimationS from './ChartsAnimationS';
import { skills, frameworks } from './SkillsData';

const Skills = (props) => {
  return (
    <div className={props.className} id="skillsSection">
      <div className="content">
        <div className="contentSkills">
          <h2 className="title">Skills</h2>
          <div className="boxLogos">
            <div className="logos">
              {skills.map((skill, name) => (
                <div className="logoS" key={name}>
                  <div className="names"> {skill.name} </div>
                  {skill.logo}
                </div>
              ))}
            </div>
          </div>
          <ChartsAnimationS />
        </div>

        <div className="contentFrameworks">
          <h2 className="title">Frameworks</h2>
          <div className="boxLogos">
            <div className="logos">
              {frameworks.map((framework, name) => (
                <div className="logoF" key={name}>
                  <div className="names"> {framework.name} </div>
                  {framework.logo}
                </div>
              ))}
            </div>
          </div>
          <ChartsAnimationF />
        </div>
      </div>
    </div>
  );
};

export default styled(Skills)`
  padding-top: 5rem;
  @media (max-width: 768px) {
    padding-top: 2rem;
  }

  .content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
    @media (max-width: 992px) {
      margin: 2rem;
      padding-top: 3rem;
      grid-template-columns: repeat(1, 1fr);
    }
    @media (max-width: 768px) {
    }
  }
  .contentSkills {
    @media (max-width: 768px) {
      width: 90%;
    }
  }
  .contentFrameworks {
    @media (max-width: 768px) {
      width: 90%;
    }
  }

  .title {
    margin-top: 3rem;
    margin-bottom: 2rem;
    text-align: center;
    font-size: 40px;
    font-weight: 700;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    background: linear-gradient(135deg, #d6ff7f 0%, #00b3cc 100%);
    @media (max-width: 768px) {
      margin-top: 1rem;
    }
  }

  .boxLogos {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 2rem;
  }

  .names {
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
  }

  .logos {
    display: flex;
    flex-direction: row;
    font-size: 5rem;
    @media (max-width: 768px) {
      font-size: 3rem;
    }
  }

  .logoS {
    padding: 1rem;
  }

  .logoS:nth-child(3) {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }
  .logoS:nth-child(4) {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  .logoS:nth-child(3) > svg {
    font-size: 4.03rem;
    border-radius: 2px;
    @media (max-width: 768px) {
      font-size: 2.3rem;
    }
  }
  .logoS:nth-child(4) > svg {
    font-size: 4.03rem;
    @media (max-width: 768px) {
      font-size: 2.3rem;
    }
  }

  .logoF {
    padding: 1rem;
    font-size: 4.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }
  .logoF > div {
    margin-bottom: 0.4rem;
  }
`;
